import { render, staticRenderFns } from "./InformationView.vue?vue&type=template&id=77e69108&"
import script from "./InformationView.vue?vue&type=script&lang=js&"
export * from "./InformationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports